import axiosInstance from "../axiosInstance.js";
import axiosStudentInstance from "../axiosStudentInstance.js";

export function getAxiosByRole(role) {
  if (role === "student") return axiosStudentInstance;
  if (role === "teacher") return axiosInstance;
  throw new Error("Invalid user role");
}
